import React from 'react';
import { MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomField } from 'src/core/forms/CustomField';
import type { DashboardBarKey } from 'src/pages/dashboard/DashboardGraph';

export const DashboardSalesChannelFilter: React.FC<{
  value: SalesChannel[];
  onChange: (value: SalesChannel[]) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <CustomField
      options={{ name: t('Sales Channel'), select: true, isMulti: true, height: '40px', topMargin: '0px' }}
      stateProps={{ state: value, setState: onChange }}
    >
      <MenuItem value="Store">{t('Store')}</MenuItem>
      <MenuItem value="Online">{t('Online')}</MenuItem>
    </CustomField>
  );
};

export const DashboardMetricFilter: React.FC<{
  value: DashboardBarKey[];
  onChange: (value: DashboardBarKey[]) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <CustomField
      options={{ name: t('Information'), select: true, isMulti: true, height: '40px', topMargin: '0px' }}
      stateProps={{ state: value, setState: onChange }}
    >
      <MenuItem value="ordersBar">{t('Orders (qty)')}</MenuItem>
      <MenuItem value="ordersValueBar">{t('Orders (value)')}</MenuItem>
      <MenuItem value="purchasesValueBar">{t('Purchases (value)')}</MenuItem>
      <MenuItem value="toShipBar">{t('To Ship')}</MenuItem>
      <MenuItem value="shippedBar">{t('Shipped')}</MenuItem>
      <MenuItem value="returnsBar">{t('Returns (qty)')}</MenuItem>
      <MenuItem value="creditNotesBar">{t('Credit Notes (qty)')}</MenuItem>
      <MenuItem value="creditNotesValueBar">{t('Credit Notes (value)')}</MenuItem>
    </CustomField>
  );
};

export const DashboardSalesRepFilter: React.FC<{
  value: string[];
  onChange: (value: string[]) => void;
  salesReps: SalesRep[];
}> = ({ value, onChange, salesReps }) => {
  const { t } = useTranslation();

  return (
    <CustomField
      options={{ name: t('Sales Reps'), select: true, isMulti: true, height: '40px', topMargin: '0px' }}
      stateProps={{ state: value, setState: onChange }}
    >
      {salesReps.map(rep => (
        <MenuItem key={rep.id} value={rep.id}>{rep.name}</MenuItem>
      ))}
    </CustomField>
  );
};

export const DashboardPeriodFilter: React.FC<{
  value: Period;
  onChange: (value: Period) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <CustomField
      options={{ name: t('Period'), select: true, height: '40px', topMargin: '0px' }}
      stateProps={{ state: value, setState: onChange }}
    >
      <MenuItem value="Week">{t('Week')}</MenuItem>
      <MenuItem value="Month">{t('Month')}</MenuItem>
      <MenuItem value="Year">{t('Year')}</MenuItem>
    </CustomField>
  );
};

export type Period = 'Week' | 'Month' | 'Year';

export type SalesChannel = 'Store' | 'Online';

export type SalesRep = { id: string; name: string };
